// import { showEncryptedMails } from './mail-obfuscator';
// import { activateYouTubeInline } from './youtube-preview';
// import { activeGoogleMaps } from './lib-2sxc-google-maps';
// import { initFancybox } from './lib-2sxc-fancybox';

// // so it can be called from the HTML when content re-initializes dynamically
// const winAny = (window as any);
// winAny.appContent = winAny.appContent || {};
// winAny.appContent.activeGoogleMaps = winAny.appContent.activeGoogleMaps || activeGoogleMaps;
// winAny.appContent.activateYouTubeInline = winAny.appContent.activateYouTubeInline || activateYouTubeInline;
// winAny.appContent.showEncryptedMails = winAny.appContent.showEncryptedMails || showEncryptedMails;
// winAny.appContent.initFancybox = initFancybox;

$(document).ready(function(){
	/* mailencrypting */
	setTimeout(function(){
		$('[data-madr1]').not('.madr-done').each(function(){
			var $this = ($(this) as any);
			var maddr = $this.attr('data-madr1') + '@' + $this.attr('data-madr2') + '.' + $this.attr('data-madr3');
			$this.after( '<a href="mailto:'+maddr+'">'+maddr+'</a>' );
			$this.addClass('madr-done').hide();
		});
	}, 500);

	let youtubeElem = document.querySelectorAll('[data-youtube^="iframe-"]');
	// If youtube element is on page
	if(youtubeElem.length != 0) {

		// goes through all youtube elements
		youtubeElem.forEach((ytElem: HTMLElement, index) => {
			
			if(!ytElem.classList.contains('added-listener')) {
				// add click event if not available 
				ytElem.addEventListener('click', () => {  
					const iframeId = ytElem.getAttribute('data-youtube');
					const iframeElem = document.getElementById(iframeId);
					const youtubeUrl = iframeElem.getAttribute('data-youtube-src');
					iframeElem.setAttribute('src', youtubeUrl);
					ytElem.classList.add('hide');
				});

				ytElem.classList.add('added-listener');
			}
			
		});  
	}
});

